import { InputAdornment, Stack, styled } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import CustomSelect from "../Input/Select";
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { ApiUrls } from "../../Utils/globalVariables";
import useFetch from "../../../Service/Hooks/useFetch";


export default function SearchPosition({ submitData, option, submitAnz }) {

    const { handleSubmit, control, reset, formState: {errors}, unregister, setValue, register } = useForm();

    const handleSubmitData = (data) => {
        
    }

    // useEffect(() => {
    //     setValue("SearchPosition", {persian_name: "برنامه نویس", anzsco: "", name: ""})
    // }, [])

    return (
        <Stack
            component="form"
            onSubmit={handleSubmit(handleSubmitData)}
        >
            <CustomSelect 
                control={control}
                name="SearchPosition"
                option={option}
                optionLable={(option) => option.persian_name ? `${option.persian_name} ${option.anzsco} ${option.name}` : ""}
                equalLable={(option, value) => `${option.persian_name} ${option.anzsco} ${option.name}` === `${value.persian_name} ${value.anzsco} ${option.name}`}
                disableClearable={true}
                freeSolo
                sx={{direction: "rtl"}}
                innerPlaceHolder="نام کد ANZSCO را وارد کنید"
                onInput={submitData}
                innerFunction={submitAnz}
                innerInputProps={{
                    startAdornment: (
                        <InputAdornment position="end">
                            <SearchOutlinedIcon sx={{mr: "1rem"}} color="primary" />
                        </InputAdornment>
                    )
                }}
            />
        </Stack>
    )
}